var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef, useState, useImperativeHandle, forwardRef } from "react";
import "../styles/ArtPreview.css";
import ImageIcon from '@mui/icons-material/Image';
import ArtGeneratorService from "../services/ArtGeneratorService";
import { getContactIcon } from "../utils/contactIcons";
import html2canvas from "html2canvas";
;
function downloadDataUrl(href, fileName) {
    var link = document.createElement('a');
    link.href = href;
    link.download = "".concat(fileName, ".png");
    document.body.appendChild(link);
    link.click();
    link.remove();
}
function saveCanvas(canvas, fileName) {
    try {
        downloadDataUrl(canvas.toDataURL('image/png'), fileName);
    }
    catch (_a) {
        canvas.toBlob(function (blob) {
            if (!blob)
                return;
            var url = URL.createObjectURL(blob);
            downloadDataUrl(url, fileName);
            URL.revokeObjectURL(url);
        });
    }
}
function exportElementAsImage(element, size, logoBase64, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var clone, canvas, err_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clone = element.cloneNode(true);
                    clone.style.position = 'fixed';
                    clone.style.left = '0px';
                    clone.style.top = '0px';
                    clone.style.width = size.width + 'px';
                    clone.style.height = size.height + 'px';
                    clone.style.opacity = '0';
                    clone.style.pointerEvents = 'none';
                    clone.style.zIndex = '-9999';
                    clone.style.transform = 'none';
                    clone.style.marginBottom = '0';
                    document.body.appendChild(clone);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    if (logoBase64) {
                        clone.querySelectorAll('img.logo-preview').forEach(function (img) {
                            img.src = logoBase64;
                        });
                    }
                    return [4 /*yield*/, Promise.all(Array.from(clone.querySelectorAll('img'))
                            .filter(function (img) { return img.src && !img.src.startsWith('data:') && !img.src.startsWith('blob:'); })
                            .map(function (img) { return __awaiter(_this, void 0, void 0, function () {
                            var b64;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, toBase64(img.src)];
                                    case 1:
                                        b64 = _a.sent();
                                        if (b64)
                                            img.src = b64;
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    clone.querySelectorAll('img').forEach(function (img) {
                        img.removeAttribute('crossOrigin');
                        img.removeAttribute('crossorigin');
                    });
                    return [4 /*yield*/, html2canvas(clone, {
                            width: size.width,
                            height: size.height,
                            scale: 1,
                            useCORS: false,
                            allowTaint: false,
                            logging: false,
                            onclone: function (_clonedDoc, clonedEl) { return applyExportCloneStyles(clonedEl); }
                        })];
                case 3:
                    canvas = _a.sent();
                    saveCanvas(canvas, fileName);
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    console.error('Erro ao exportar:', err_1);
                    return [3 /*break*/, 6];
                case 5:
                    if (clone.parentNode) {
                        clone.remove();
                    }
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getSvaSizeClass(count) {
    if (count === 0)
        return 'combo-no-svas';
    if (count <= 2)
        return 'combo-few-svas';
    return 'combo-all-svas';
}
function getContrastColor(hex) {
    var h = hex.replace('#', '');
    if (h.length < 6)
        return '#FFFFFF';
    var r = Number.parseInt(h.substring(0, 2), 16);
    var g = Number.parseInt(h.substring(2, 4), 16);
    var b = Number.parseInt(h.substring(4, 6), 16);
    var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#000000' : '#FFFFFF';
}
function toRelativeUrl(url) {
    var apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    var storageBase = (process.env.REACT_APP_STORAGE_URL || '').replace(/\/$/, '');
    if (storageBase && url.startsWith(storageBase)) {
        try {
            var u = new URL(storageBase);
            return url.slice(u.origin.length);
        }
        catch (_a) {
            return url;
        }
    }
    if (apiBase && url.startsWith(apiBase))
        return url.slice(apiBase.length);
    if (url.startsWith(window.location.origin))
        return url.slice(window.location.origin.length);
    return url;
}
function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
function fetchImageAsDataUrl(u) {
    return __awaiter(this, void 0, void 0, function () {
        var res, blob, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, fetch(u)];
                case 1:
                    res = _b.sent();
                    if (!res.ok)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, res.blob()];
                case 2:
                    blob = _b.sent();
                    if (!blob.type.startsWith('image/'))
                        return [2 /*return*/, null];
                    return [4 /*yield*/, blobToDataUrl(blob)];
                case 3: return [2 /*return*/, _b.sent()];
                case 4:
                    _a = _b.sent();
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function toBase64(url) {
    return __awaiter(this, void 0, void 0, function () {
        var relUrl, dataUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    relUrl = toRelativeUrl(url);
                    return [4 /*yield*/, fetchImageAsDataUrl(relUrl)];
                case 1:
                    dataUrl = _a.sent();
                    if (!(!dataUrl && relUrl !== url)) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchImageAsDataUrl(url)];
                case 2:
                    dataUrl = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!dataUrl)
                        console.error('[export] erro ao converter:', url);
                    return [2 /*return*/, dataUrl];
            }
        });
    });
}
function applyExportCloneStyles(clonedEl) {
    clonedEl.style.opacity = '1';
    clonedEl.querySelectorAll('.combo-box').forEach(function (el) {
        el.style.boxShadow = 'none';
        el.style.filter = 'none';
    });
    clonedEl.querySelectorAll('.image-overlay').forEach(function (overlay) {
        var img = overlay.querySelector('img.preview-image');
        if (!(img === null || img === void 0 ? void 0 : img.src))
            return;
        overlay.style.backgroundImage = "url(\"".concat(img.src, "\")");
        overlay.style.backgroundSize = 'cover';
        overlay.style.backgroundPosition = 'center';
        overlay.style.backgroundRepeat = 'no-repeat';
        img.remove();
    });
}
var COMBO_BOX_COLOR = "#000000";
var COMBO_TEXT_COLOR = "#FFFFFF";
function shrinkFontToFit(el, maxFont, minFont, overflows) {
    var fontSize = maxFont;
    el.style.fontSize = fontSize + 'px';
    while (fontSize > minFont && overflows()) {
        fontSize -= 1;
        el.style.fontSize = fontSize + 'px';
    }
}
function fitInfoText(el, previewWidth, isStory, maxHeight) {
    var target = isStory ? previewWidth - 160 : previewWidth - 560;
    var maxFont = isStory ? 56 : 42;
    var minFont = isStory ? 20 : 14;
    el.style.maxWidth = target + 'px';
    var fontSize = maxFont;
    var applyFont = function (size) {
        fontSize = size;
        el.style.fontSize = size + 'px';
        el.style.lineHeight = Math.round(size * 1.25) + 'px';
    };
    applyFont(maxFont);
    el.style.whiteSpace = 'nowrap';
    while (fontSize > minFont && el.scrollWidth > target) {
        applyFont(fontSize - 1);
    }
    el.style.whiteSpace = el.scrollWidth > target ? 'normal' : 'nowrap';
    if (maxHeight != null) {
        while (fontSize > minFont && el.offsetHeight > maxHeight) {
            applyFont(fontSize - 1);
        }
    }
}
function fitContacts(el, previewWidth, contactCount) {
    var target = previewWidth - 300;
    el.style.maxWidth = target + 'px';
    var maxFont = 30;
    var minFont = contactCount >= 3 ? 22 : 14;
    el.style.flexWrap = 'nowrap';
    shrinkFontToFit(el, maxFont, minFont, function () { return el.scrollWidth > el.clientWidth; });
    el.style.flexWrap = el.scrollWidth > el.clientWidth ? 'wrap' : 'nowrap';
}
function renderCombo(combo, contentSuppliersProducts) {
    var _a, _b;
    var has_price = ((_a = combo.monthlyValue) === null || _a === void 0 ? void 0 : _a.trim()) !== '';
    var has_speed = ((_b = combo.velocityValue) === null || _b === void 0 ? void 0 : _b.trim()) !== '';
    var has_svas = combo.selectedSvas.length > 0;
    var svaSizeClass = getSvaSizeClass(combo.selectedSvas.length);
    var _c = has_price
        ? Number(combo.monthlyValue).toFixed(2).split('.')
        : ['', ''], valueInt = _c[0], valueCents = _c[1];
    return (_jsxs("div", __assign({ className: "combo-box ".concat(svaSizeClass), style: { backgroundColor: COMBO_BOX_COLOR, color: COMBO_TEXT_COLOR } }, { children: [_jsxs("div", __assign({ className: "combo-info" }, { children: [has_speed && (_jsxs("p", __assign({ className: "combo-speed" }, { children: [combo.velocityValue, " ", _jsx("span", { children: combo.velocityUnit === "MEGA" ? "MB" : combo.velocityUnit })] }))), has_price && (_jsxs("div", __assign({ className: "combo-value" }, { children: [_jsx("p", __assign({ className: "combo-label" }, { children: "por apenas" })), _jsxs("p", __assign({ className: "combo-price-line" }, { children: [_jsx("span", __assign({ className: "rs" }, { children: "R$" })), " ", valueInt, ",", valueCents, "/m\u00EAs"] }))] })))] })), (has_price || has_speed) && has_svas && _jsx("hr", {}), has_svas && (_jsxs("div", __assign({ className: "combo-svas" }, { children: [_jsx("p", __assign({ className: "combo-sva-title" }, { children: "ASSINATURAS INCLUSAS" })), _jsx("div", __assign({ className: "combo-sva-images-wrapper" }, { children: combo.selectedSvas.map(function (svaId) {
                            var product = contentSuppliersProducts.find(function (p) { return String(p.id) === String(svaId); });
                            if (!product)
                                return null;
                            return (_jsx("img", { src: product.img_path, alt: product.name, className: "combo-sva-image" }, product.id));
                        }) }))] })))] }), combo.comboNumber));
}
function ContactList(_a) {
    var contactInfo = _a.contactInfo, secondaryColor = _a.secondaryColor, contactClass = _a.contactClass, innerRef = _a.innerRef;
    return (_jsx("div", __assign({ ref: innerRef, className: contactClass }, { children: contactInfo.filter(function (contact) { return contact.typeId && contact.value; }).map(function (contact) { return (_jsxs("div", __assign({ className: "contact-value", style: { color: secondaryColor } }, { children: [getContactIcon(contact.typeId, { marginRight: 4 }), _jsx("p", { children: contact.value })] }), "".concat(contact.typeId, "-").concat(contact.value))); }) })));
}
function VerticalRetratoLayout(props) {
    var imagePosition = props.imagePosition, selectedImage = props.selectedImage, prodUrl = props.prodUrl, logoUrl = props.logoUrl, titleLabel = props.titleLabel, secondaryColor = props.secondaryColor, validCombos = props.validCombos, contentSuppliersProducts = props.contentSuppliersProducts, infos = props.infos, svas = props.svas, contactInfo = props.contactInfo, contactClass = props.contactClass;
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "image-overlay right-middle" }, { children: selectedImage ? (_jsx("img", { src: "".concat(prodUrl, "/").concat(selectedImage.path), alt: "", className: "preview-image" })) : (_jsx(ImageIcon, { style: { fontSize: 140 } })) })), _jsxs("div", __assign({ className: "content-area left-side combos-".concat(validCombos.length, " ").concat(infos.length > 0 || svas.length > 0 ? 'multiple-infos' : '') }, { children: [logoUrl && (_jsx("img", { src: logoUrl, alt: "Preview da Arte", className: "logo-preview ".concat(imagePosition) })), titleLabel && (_jsx("div", __assign({ className: "title-side" }, { children: _jsx("p", __assign({ className: "title-label", style: { color: secondaryColor } }, { children: titleLabel })) }))), validCombos.length > 0 && (_jsx("div", __assign({ className: "combo-container count-".concat(validCombos.length, " left-side") }, { children: validCombos.map(function (combo) { return renderCombo(combo, contentSuppliersProducts); }) }))), _jsx("div", __assign({ className: "side-infos left-side" }, { children: _jsx("div", __assign({ className: "other-information " }, { children: infos.length > 0 && (_jsx("ul", { children: infos.map(function (info) { return (_jsxs("li", __assign({ style: { color: secondaryColor } }, { children: ["* ", info.value] }), info.id)); }) })) })) })), _jsx(ContactList, { contactInfo: contactInfo, secondaryColor: secondaryColor, contactClass: contactClass })] }))] }));
}
function StandardLayout(props) {
    var imagePosition = props.imagePosition, selectedImage = props.selectedImage, prodUrl = props.prodUrl, logoUrl = props.logoUrl, titleLabel = props.titleLabel, secondaryColor = props.secondaryColor, validCombos = props.validCombos, contentSuppliersProducts = props.contentSuppliersProducts, infos = props.infos, contactInfo = props.contactInfo, contactClass = props.contactClass, infoTextRef = props.infoTextRef, contactsRef = props.contactsRef, logoRef = props.logoRef;
    return (_jsxs(_Fragment, { children: [logoUrl && (_jsx("img", { ref: logoRef, src: logoUrl, alt: "Preview da Arte", className: "logo-preview ".concat(imagePosition) })), (imagePosition === "horizontal-retrato" || imagePosition === "horizontal") && (_jsx("div", __assign({ className: "image-overlay top-full-width" }, { children: selectedImage ? (_jsx("img", { src: "".concat(prodUrl, "/").concat(selectedImage.path), alt: "", className: "preview-image" })) : (_jsx(ImageIcon, { style: { fontSize: 140 } })) }))), titleLabel && (_jsx("div", __assign({ className: "title-bottom" }, { children: _jsx("p", __assign({ className: "title-label", style: { color: secondaryColor } }, { children: titleLabel })) }))), validCombos.length > 0 && (_jsx("div", __assign({ className: "combo-container bottom-centered one-or-two-combos ".concat(validCombos.length === 1 ? "single-combo" : "multi-combo") }, { children: validCombos.map(function (combo) { return renderCombo(combo, contentSuppliersProducts); }) }))), _jsx("div", __assign({ className: "side-infos bottom-centered" }, { children: infos.some(function (info) { return info.id && info.value; }) && (_jsx("div", __assign({ className: "other-information " }, { children: _jsx("p", __assign({ ref: infoTextRef, style: { color: secondaryColor } }, { children: infos.filter(function (info) { return info.id && info.value; }).map(function (info, index, arr) { return "".concat(info.value).concat(index < arr.length - 1 ? ', ' : ''); }) })) }))) })), _jsx(ContactList, { contactInfo: contactInfo, secondaryColor: secondaryColor, contactClass: contactClass, innerRef: contactsRef })] }));
}
function renderArtContent(imagePosition, props) {
    if (!imagePosition) {
        return (_jsx("div", __assign({ className: "empty-state" }, { children: _jsx(ImageIcon, { style: { fontSize: 200 } }) })));
    }
    if (imagePosition === "vertical-retrato") {
        return _jsx(VerticalRetratoLayout, __assign({}, props));
    }
    return _jsx(StandardLayout, __assign({}, props));
}
function useArtPreviewData(formData) {
    var _this = this;
    var titleId = formData.titleId, colorCombinationId = formData.colorCombinationId, logoFile = formData.logoFile, logoFilePath = formData.logoFilePath, _a = formData.additionalInfos, additionalInfos = _a === void 0 ? [] : _a;
    var prodUrl = process.env.REACT_APP_STORAGE_URL;
    var _b = useState([]), titles = _b[0], setTitles = _b[1];
    var _c = useState(""), titleLabel = _c[0], setTitleLabel = _c[1];
    var _d = useState([]), infos = _d[0], setInfos = _d[1];
    var _e = useState([]), svas = _e[0], setSvas = _e[1];
    var _f = useState(null), colorCombination = _f[0], setColorCombination = _f[1];
    var _g = useState(null), logoUrl = _g[0], setLogoUrl = _g[1];
    var _h = useState(null), logoBase64 = _h[0], setLogoBase64 = _h[1];
    useEffect(function () {
        var active = true;
        var fetchStaticData = function () { return __awaiter(_this, void 0, void 0, function () {
            var titlesData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ArtGeneratorService.getTitles()];
                    case 1:
                        titlesData = _a.sent();
                        if (!active)
                            return [2 /*return*/];
                        setTitles(titlesData);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchStaticData();
        return function () { active = false; };
    }, []);
    useEffect(function () {
        var active = true;
        var fetchColor = function () { return __awaiter(_this, void 0, void 0, function () {
            var colorsData, foundColor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ArtGeneratorService.getColorCombinations()];
                    case 1:
                        colorsData = _a.sent();
                        if (!active)
                            return [2 /*return*/];
                        foundColor = colorsData.find(function (c) { return String(c.id) === String(colorCombinationId); });
                        setColorCombination(foundColor || null);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchColor();
        return function () { active = false; };
    }, [colorCombinationId]);
    useEffect(function () {
        setInfos(additionalInfos.filter(function (i) { return i.type === 'info'; }));
        setSvas(additionalInfos.filter(function (i) { return i.type === 'sva'; }));
    }, [additionalInfos]);
    useEffect(function () {
        var selected = titles.find(function (title) { return title.id === titleId; });
        setTitleLabel((selected === null || selected === void 0 ? void 0 : selected.label) || "");
    }, [titles, titleId]);
    useEffect(function () {
        if (logoFile instanceof File) {
            var url_1 = URL.createObjectURL(logoFile);
            setLogoUrl(url_1);
            var reader = new FileReader();
            reader.onload = function (e) { var _a, _b; return setLogoBase64((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result) !== null && _b !== void 0 ? _b : null); };
            reader.readAsDataURL(logoFile);
            return function () { return URL.revokeObjectURL(url_1); };
        }
        if (logoFilePath) {
            var fullUrl = "".concat(prodUrl, "/").concat(logoFilePath);
            setLogoUrl(fullUrl);
            setLogoBase64(null);
            return;
        }
        setLogoUrl(null);
        setLogoBase64(null);
    }, [logoFile, logoFilePath, prodUrl]);
    return { infos: infos, svas: svas, titleLabel: titleLabel, colorCombination: colorCombination, logoUrl: logoUrl, logoBase64: logoBase64 };
}
var ArtPreview = forwardRef(function (_a, ref) {
    var formData = _a.formData, images = _a.images, comboSvasOptions = _a.comboSvasOptions, contentSuppliersProducts = _a.contentSuppliersProducts;
    var format = formData.format, imagePosition = formData.imagePosition, _b = formData.combos, combos = _b === void 0 ? [] : _b, colorCombinationId = formData.colorCombinationId, _c = formData.contactInfo, contactInfo = _c === void 0 ? [] : _c;
    var _d = useArtPreviewData(formData), infos = _d.infos, svas = _d.svas, titleLabel = _d.titleLabel, colorCombination = _d.colorCombination, logoUrl = _d.logoUrl, logoBase64 = _d.logoBase64;
    var exportRef = useRef(null);
    var wrapperRef = useRef(null);
    var infoTextRef = useRef(null);
    var contactsRef = useRef(null);
    var logoRef = useRef(null);
    var _e = useState(1), scale = _e[0], setScale = _e[1];
    var prod_url = process.env.REACT_APP_STORAGE_URL;
    console.timeLog('colorCombinationId', colorCombinationId);
    var size = formData.format === "portrait"
        ? { width: 1080, height: 1350 }
        : { width: 1080, height: 1920 };
    useEffect(function () {
        var calculateScale = function () {
            if (!wrapperRef.current)
                return;
            var containerWidth = wrapperRef.current.clientWidth;
            var maxHeight = window.innerHeight * 0.85;
            var scaleByWidth = containerWidth / size.width;
            var scaleByHeight = maxHeight / size.height;
            var newScale = Math.min(scaleByWidth, scaleByHeight, 1);
            setScale(newScale);
        };
        calculateScale();
        var raf = requestAnimationFrame(calculateScale);
        window.addEventListener('resize', calculateScale);
        return function () {
            cancelAnimationFrame(raf);
            window.removeEventListener('resize', calculateScale);
        };
    }, [size.width, size.height]);
    var selectedImage = images.find(function (img) { return String(img.id) === String(formData.imageId); });
    useLayoutEffect(function () {
        var _a;
        var el = contactsRef.current;
        if (!el)
            return;
        if (format !== 'portrait') {
            el.style.maxWidth = '';
            el.style.fontSize = '';
            return;
        }
        var previewWidth = ((_a = exportRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || size.width;
        var contactCount = contactInfo.filter(function (c) { return c.typeId && c.value; }).length;
        fitContacts(el, previewWidth, contactCount);
    }, [contactInfo, format, size.width]);
    useLayoutEffect(function () {
        var el = infoTextRef.current;
        var root = exportRef.current;
        if (!el || !root)
            return;
        var previewWidth = root.clientWidth || size.width;
        var isStory = format === 'landscape';
        var rootRect = root.getBoundingClientRect();
        var currentScale = rootRect.width / size.width || 1;
        var elTop = el.getBoundingClientRect().top;
        var obstacles = [logoRef.current, contactsRef.current].filter(function (node) { return node !== null; });
        var gaps = obstacles
            .map(function (node) { return (node.getBoundingClientRect().top - elTop) / currentScale; })
            .filter(function (gap) { return gap > 0; });
        var maxHeight = gaps.length > 0 ? Math.min.apply(Math, gaps) - 16 : null;
        fitInfoText(el, previewWidth, isStory, maxHeight);
    }, [infos, contactInfo, logoUrl, format, size.width]);
    useImperativeHandle(ref, function () { return ({
        exportAsImage: function (fileName) {
            if (fileName === void 0) { fileName = "arte"; }
            return __awaiter(this, void 0, void 0, function () {
                var element;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            element = exportRef.current;
                            if (!element) {
                                console.error('exportRef.current está null');
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, exportElementAsImage(element, size, logoBase64, fileName)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    }); }, [logoBase64, size.width, size.height]);
    var primaryColor = (colorCombination === null || colorCombination === void 0 ? void 0 : colorCombination.hex) || "#000000";
    var secondaryColor = getContrastColor(primaryColor);
    var isHorizontal = imagePosition === "horizontal" || imagePosition === "horizontal-retrato";
    var hasLogo = !!logoUrl;
    var contactVariant = 'bottom-centered';
    if (isHorizontal && hasLogo) {
        contactVariant = 'bottom-left-column';
    }
    else if (!hasLogo && contactInfo.length === 2) {
        contactVariant = 'bottom-sides';
    }
    var contactClass = "contacts-infos ".concat(contactVariant);
    var validCombos = combos.filter(function (combo) {
        var _a, _b;
        return combo.selectedSvas.length > 0 ||
            ((_a = combo.monthlyValue) === null || _a === void 0 ? void 0 : _a.trim()) !== '' ||
            ((_b = combo.velocityValue) === null || _b === void 0 ? void 0 : _b.trim()) !== '';
    });
    var scaledHeight = size.height * scale;
    var offsetBottom = size.height - scaledHeight;
    var layoutProps = {
        imagePosition: imagePosition,
        selectedImage: selectedImage,
        prodUrl: prod_url,
        logoUrl: logoUrl,
        titleLabel: titleLabel,
        secondaryColor: secondaryColor,
        validCombos: validCombos,
        contentSuppliersProducts: contentSuppliersProducts,
        infos: infos,
        svas: svas,
        contactInfo: contactInfo,
        contactClass: contactClass,
        infoTextRef: infoTextRef,
        contactsRef: contactsRef,
        logoRef: logoRef,
    };
    return (_jsx("div", __assign({ ref: wrapperRef, className: "art-wrapper ".concat(format === 'portrait' ? 'format-portrait' : '') }, { children: _jsx("div", __assign({ id: "art-image-preview", ref: exportRef, className: "art-image-preview format-".concat(format || "default"), style: {
                backgroundColor: colorCombination ? primaryColor : "rgba(217, 217, 217, 1)",
                width: "".concat(size.width, "px"),
                height: "".concat(size.height, "px"),
                transform: "scale(".concat(scale, ")"),
                transformOrigin: 'top left',
                marginBottom: "-".concat(offsetBottom, "px"),
                marginRight: "-".concat(size.width * (1 - scale), "px"),
            } }, { children: renderArtContent(imagePosition, layoutProps) })) })));
});
export default ArtPreview;
